import { PermissionRoles } from "../../types/enums";
import { Stack } from "@mui/material";
import { permissionRolesItems } from "../../types/genereal";

export const PermissionRoleMapper = ({ role }: { role: PermissionRoles }) => {
  const item = permissionRolesItems[role];
  if (!item) return null;

  return (
    <Stack alignItems="flex-start">
      <span
        style={{
          borderRadius: "16px",
          padding: "5px 12px",
          fontSize: "13px",
          lineHeight: "12px",
          fontWeight: 500,
          color: item.color,
          backgroundColor: item.backgroundColor,
          border: `1px solid ${item.borderColor}`,
          textAlign: "left",
          userSelect: "none",
          letterSpacing: "0.35px",
        }}
      >
        {item.title}
      </span>
    </Stack>
  );
};
